module.exports = __webpack_public_path__ + "static/media/act02.72b822bc.m4a";